module.exports = function(app) {
    app.directive('providerImage', [function() {
        return {
            restrict: 'A',
            replace: true,

            scope: {
                resultImage: '=',
                resultGender:'=',
                resultName:'='
            },

            template:
            '<span class="provider-Image">'+
                '<span data-ng-show="resultGender==\'Female\'&&!resultImage">'+
                        '<img data-ng-src="/bootstrap/v4/resources/img/female.png" alt="{{resultName}}"/>'+
                '</span>'+
                '<span data-ng-show="resultGender==\'Male\'&&!resultImage">'+
                    '<img data-ng-src="/bootstrap/v4/resources/img/male.png" alt="{{resultName}}"/>'+
                '</span>'+
                '<span data-ng-show="resultGender==\'Unknown\'&&!resultImage">'+
                    '<img data-ng-src="/bootstrap/v4/resources/img/male.png" alt="{{resultName}}"/>'+
                '</span>'+
                '<span data-ng-show="resultImage">'+
                    '<img data-ng-src="{{resultImage}}" alt="{{resultName}}"/>'+
                '</span>'+
                '<span data-ng-show="!resultGender">'+
                    '<img data-ng-src="/bootstrap/v4/resources/img/facility.png" alt="{{resultName}}"/>'+
                '</span>'+
            '</span>'
        };
    }]);
}